import styles from '../css/main.scss'
import initializeAiticketMap from './map/initialize'

window.initializeMap = initializeAiticketMap



// WEBPACK FOOTER //
// ./app/app.js